export class MissingParamError extends Error {
  constructor(paramName: string) {
    super(`URL parameter ${paramName} is missing or undefined`);
  }
}

export class MissingItemError extends Error {
  constructor(itemName: string) {
    super(`${itemName} is missing or undefined`);
  }
}

export class NotFoundError extends Error {
  constructor(itemName: string) {
    super(`Could not find the matching ${itemName}`);
  }
}

export class PageNotFoundError extends Error {}
